import Vue from 'vue';
import Component from 'vue-class-component';
import runtimeProcessorModule from '@/store/modules/runtime-processor.module';
import {TIMER_TYPE} from '@/types/timer';
import {notificationModule} from '@/store/modules/notification.module';
import {UserAnswer, NotificationCommand, NotificationType} from '@/types/notification';
import WorkoutActiveTimerComponent from '@/components/workout-active-timer/workout-active-timer.component.vue';
import timeformat from '@/filters/timeformat';
import {websoketConnectionModule} from '@/store/modules/websocket-connection.module';
import {BaseWorkout, PAUSE_TIMEOUT, RESUME_TIMEOUT} from '@/types/workouts';
import {CTRL_COMMAND} from '@/types/socket';
import {ctrlCmdModule} from '@/store/modules/control-commands.module';
import workoutActiveModule from '@/store/modules/egym-training-workout-active.module';
import {eGymTrainingsModule} from "@/store/modules/egym-trainings.module";
import egymWorkoutActiveManager from "@/store/managers/egym-workout-active.manager";
import egymTrainingWorkoutActiveModule from "@/store/modules/egym-training-workout-active.module";

@Component({
    components: {
        'timer': WorkoutActiveTimerComponent
    },
    filters: {timeformat},
})
export default class EgymTrainingActivePageComponent extends Vue
{

    private notificationAnswerWatcher!: CallableFunction;
    private timeFrameWatcher!: CallableFunction;
    private runtimeProcessWatcher!: CallableFunction;

    get isItPaused() {return runtimeProcessorModule.paused;}

    get timerCurrentTime(): number 
    {   
        if (egymTrainingWorkoutActiveModule.isItRFT) {
            return runtimeProcessorModule.currentTime
        } else if (egymTrainingWorkoutActiveModule.isItACircuit) {
            return ((workoutActiveModule.totalTime as number) -
            (workoutActiveModule.elapsedTime as number) -
            runtimeProcessorModule.elapsedTimeSeconds)
            * 1000 // to MS
        }
        return 0
    }

    get showHours()
    {
        return (workoutActiveModule.totalTime as number / 60 / 60) >= 1;
    }

    mounted() 
    {
        this.notificationAnswerWatcher = notificationModule.$watch(
            thisModule => thisModule.answer, this.userAnswerHandler);

        this.runtimeProcessWatcher = runtimeProcessorModule.$watch(
            timerModule => timerModule.status,
            status => egymWorkoutActiveManager.runtimeStateWatcher(status)
        );

        ctrlCmdModule.$watch(module => module.workoutCmdLastFeedback, 
            lastMessage => egymWorkoutActiveManager.feedbackCmdWatcher(lastMessage))

        window.setTimeout(() =>
        {
            // if workout didn't start
            if (egymTrainingWorkoutActiveModule.currentTimeMs <= 1) {
                websoketConnectionModule.reconnect();
                this.$router.back();
            }
        }, 2 * 1000); // 2 seconds delay before error

        egymWorkoutActiveManager.start()
    }

    onForward()
    {
        if (!workoutActiveModule.isItPreparationTime) {
            if (workoutActiveModule.isItTheLastTimeFrameInSet) {
                this.stop();
            } else {
                egymWorkoutActiveManager.forward();
            }
        } else if (!workoutActiveModule.isItTheLastTimeFrameInSet) {
            egymWorkoutActiveManager.forward();
        }
    }

    onBackward() { egymWorkoutActiveManager.backward() }

    pause() 
    {
        workoutActiveModule.pause();
        const tDialog = window.setTimeout(() =>
        {
            notificationModule.showNotification({command: NotificationCommand.RESUME_WORKOUT, type: NotificationType.CONFIRM});
            const tResume = window.setTimeout(() => this.resume(), RESUME_TIMEOUT);
            runtimeProcessorModule.changeActionTimeout(tResume);
        }, PAUSE_TIMEOUT);
        runtimeProcessorModule.changeActionTimeout(tDialog);
    }

    resume() 
    {
        if (runtimeProcessorModule.status.paused) {
            workoutActiveModule.resume();
            notificationModule.hideNotification();
            runtimeProcessorModule.changeActionTimeout(0);
        }
    }

    stop() 
    {
        notificationModule.showNotification({command: NotificationCommand.ARE_YOU_SURE, type: NotificationType.CONFIRM});
    }

    userAnswerHandler(answer: UserAnswer) 
    {
        if (notificationModule.command == NotificationCommand.RESUME_WORKOUT) {
            if (answer === UserAnswer.POSITIVE) {
                this.resume();
            } else if (answer === UserAnswer.NEGATIVE) {
                egymWorkoutActiveManager.stop();
            }
        } else if (notificationModule.command == NotificationCommand.ARE_YOU_SURE && answer === UserAnswer.POSITIVE) {
            egymWorkoutActiveManager.stop();
        }
    }

    beforeDestroy() 
    {
        [
            this.notificationAnswerWatcher,
            this.runtimeProcessWatcher,
            this.timeFrameWatcher
        ].forEach(unsubscibe => unsubscibe != undefined ? unsubscibe() : 0);
        ctrlCmdModule.cleanUp()
        workoutActiveModule.resetToDefault();
        runtimeProcessorModule.reset()
    }
}